import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import Facades from "./+state/facades";
import Services from "./+state/services";

@NgModule({
  imports: [CommonModule],
  providers: [Facades, Services]
})
export class LeftMenuDataAccessModule {}
